import type { BankTemplate } from "../core/parser/template";
import { demoBankTemplate } from "./demoBank";
import { raiffeisenRsTemplate } from "./raiffeisenRs";
import { altaBankaRsTemplate } from "./altaBankaRs";
import { altaCorpRsTemplate } from "./altaCorpRs";
import { otpBankaRsTemplate } from "./otpBankaRs";

// All known bank templates. Adding a bank = append its template here.
// First wave (per brief): Banca Intesa, Raiffeisen, UniCredit, OTP, AIK,
// Poštanska štedionica (RS) + Tinkoff/T-Bank, Sber (RU). The demo template
// proves the architecture; real ones slot in identically.
export const TEMPLATES: BankTemplate[] = [
  raiffeisenRsTemplate,
  altaBankaRsTemplate,
  altaCorpRsTemplate,
  otpBankaRsTemplate,
  demoBankTemplate,
];

export interface DetectionResult {
  template: BankTemplate;
  score: number;
}

/** Rank templates by detection confidence against the document text. */
export function detectTemplates(fullText: string): DetectionResult[] {
  return TEMPLATES.map((template) => ({
    template,
    score: template.detect(fullText),
  }))
    .filter((r) => r.score > 0)
    .sort((a, b) => b.score - a.score);
}

/** Best-matching template, or null if nothing recognises the document. */
export function bestTemplate(fullText: string): BankTemplate | null {
  const ranked = detectTemplates(fullText);
  return ranked.length > 0 ? ranked[0]!.template : null;
}
